/* Arrow buttons for the horizontal scroll rows: product-carousel,
   featured-blog and product-recommendations. Markup contract: a
   <button data-carousel-dir="prev|next" aria-controls="ID"> pair
   pointing at the scrolling list's id.
   Lives in an external file (not inline) because the storefront's
   instant-loader app swaps page content into the DOM, and inline
   scripts injected that way never execute. Clicks and scrolls are
   handled by delegated listeners, so swapped-in carousels work too;
   a MutationObserver refreshes the arrow states after a swap. */
(function () {
	if (window.SKProductCarousel) return;
	window.SKProductCarousel = true;

	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	// distance between the starts of two neighbouring cards = one card + gap
	function step(list) {
		var cards = list.children;
		if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
		return list.clientWidth;
	}

	function buttonsFor(list) {
		return list.id
			? document.querySelectorAll('[data-carousel-dir][aria-controls="' + list.id + '"]')
			: [];
	}

	// grey out an arrow when there is nothing more to scroll that way;
	// aria-disabled (not disabled) so a focused button keeps focus
	function update(list) {
		var max = list.scrollWidth - list.clientWidth - 1;
		buttonsFor(list).forEach(function (btn) {
			var atEdge = btn.getAttribute('data-carousel-dir') === 'prev'
				? list.scrollLeft <= 1
				: list.scrollLeft >= max;
			btn.setAttribute('aria-disabled', atEdge ? 'true' : 'false');
		});
	}

	function updateAll() {
		var seen = {};
		document.querySelectorAll('[data-carousel-dir]').forEach(function (btn) {
			var id = btn.getAttribute('aria-controls');
			var list = id && !seen[id] && document.getElementById(id);
			if (!list) return;
			seen[id] = true;
			update(list);
		});
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest('[data-carousel-dir]');
		if (!btn) return;
		var list = document.getElementById(btn.getAttribute('aria-controls'));
		if (!list) return;
		var dir = btn.getAttribute('data-carousel-dir') === 'prev' ? -1 : 1;
		list.scrollBy({ left: dir * step(list), behavior: reducedMotion ? 'auto' : 'smooth' });
	});

	// element scroll events don't bubble, so listen in the capture phase
	var queued = null;
	document.addEventListener('scroll', function (e) {
		var list = e.target;
		if (!list.id || queued === list || !buttonsFor(list).length) return;
		queued = list;
		requestAnimationFrame(function () {
			queued = null;
			update(list);
		});
	}, true);

	function boot() {
		updateAll();
		window.addEventListener('resize', updateAll);
		window.addEventListener('load', updateAll);
		var pending;
		new MutationObserver(function () {
			clearTimeout(pending);
			pending = setTimeout(updateAll, 100);
		}).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
